"use client";
import { Scrollbars } from "react-custom-scrollbars-2";
import IMAGES from "@/data/assetData";
import Link from "next/link";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import { BASE_URL_CITY } from "@/data/assetData";

const elementsRow1 = [
  {
    id: 1,
    cityName: "Bangalore",
    imageUrl: IMAGES.Bangalore,
    linkUrl: "/bike-rental-in-bangalore/",
  },
  {
    id: 2,
    cityName: "Chennai",
    imageUrl: IMAGES.Chennai,
    linkUrl: "/bike-rental-in-chennai/",
  },

  {
    id: 3,
    cityName: "Hyderabad",
    imageUrl: IMAGES.Hyderabad,
    linkUrl: "/bike-rental-in-hyderabad/",
  },
  {
    id: 4,
    cityName: "Mumbai",
    imageUrl: IMAGES.Mumbai,
    linkUrl: "/bike-rental-in-mumbai/",
  },
  {
    id: 5,
    cityName: "Gokarna",
    imageUrl: IMAGES.Gokarna,
    linkUrl: "/bike-rental-in-gokarna/",
  },
  {
    id: 6,
    cityName: "Goa",
    imageUrl: IMAGES.Goa,
    linkUrl: "/bike-rental-in-goa/",
  },
  {
    id: 7,
    cityName: "Pondicherry",
    imageUrl: IMAGES.Pondicherry,
    linkUrl: "/bike-rental-in-pondicherry/",
  },
  {
    id: 8,
    cityName: "Pune",
    imageUrl: IMAGES.Pune,
    linkUrl: "/bike-rental-in-pune/",
  },
  {
    id: 9,
    cityName: "Delhi",
    imageUrl: IMAGES.Delhi,
    linkUrl: "/bike-rental-in-delhi/",
  },
  {
    id: 10,
    cityName: "Manali",
    imageUrl: IMAGES.Manali,
    linkUrl: "/bike-rental-in-manali/",
  },
  {
    id: 11,
    cityName: "Kolkata",
    imageUrl: IMAGES.Kolkata,
    linkUrl: "/bike-rental-in-kolkata/",
  },
  {
    id: 12,
    cityName: "Chandigarh",
    imageUrl: IMAGES.Chandigarh,
    linkUrl: "/bike-rental-in-chandigarh/",
  },
  {
    id: 13,
    cityName: "Kochi",
    imageUrl: IMAGES.Kochi,
    linkUrl: "/bike-rental-in-kochi/",
  },
];

const elementsRow2 = [
  {
    id: 14,
    cityName: "Ahmedabad",
    imageUrl: IMAGES.Ahmedabad,
    linkUrl: "/bike-rental-in-ahmedabad/",
  },
  {
    id: 15,
    cityName: "Guwahati",
    imageUrl: IMAGES.Guwahati,
    linkUrl: "/bike-rental-in-guwahati/",
  },
  {
    id: 16,
    cityName: "Coimbatore",
    imageUrl: IMAGES.Coimbatore,
    linkUrl: "/bike-rental-in-coimbatore/",
  },
  {
    id: 17,
    cityName: "Vizag",
    imageUrl: IMAGES.Vizag,
    linkUrl: "/bike-rental-in-vizag/",
  },
  {
    id: 18,
    cityName: "Dehradun",
    imageUrl: IMAGES.Dehradun,
    linkUrl: "/bike-rental-in-dehradun/",
  },
  {
    id: 19,
    cityName: "Mangalore",
    imageUrl: IMAGES.Mangalore,
    linkUrl: "/bike-rental-in-mangalore/",
  },
  {
    id: 20,
    cityName: "Raipur",
    imageUrl: IMAGES.Raipur,
    linkUrl: "/bike-rental-in-raipur/",
  },
  {
    id: 21,
    cityName: "Leh",
    imageUrl: IMAGES.Leh,
    linkUrl: "/bike-rental-in-leh/",
  },
  {
    id: 22,
    cityName: "Bhubaneswar",
    imageUrl: IMAGES.Bhubaneswar,
    linkUrl: "/bike-rental-in-bhubaneswar/",
  },
  {
    id: 23,
    cityName: "Hampi",
    imageUrl: IMAGES.Hampi,
    linkUrl: "/bike-rental-in-hampi/",
  },
  {
    id: 24,
    cityName: "Dandeli",
    imageUrl: IMAGES.Dandeli,
    linkUrl: "/bike-rental-in-dandeli/",
  },
 
  {
    id: 25,
    cityName: "Siliguri",
    imageUrl: IMAGES.Siliguri,
    linkUrl: "/bike-rental-in-siliguri/",
  },
  {
    id: 26,
    cityName: "Gurgaon",
    imageUrl: IMAGES.Gurugram,
    linkUrl: "/bike-rental-in-gurgaon/",
  },
  
];



const TopCities = () => {
  const numRows = 2;
  const [scrollbarHeight, setScrollbarHeight] = useState(420);
    useEffect(() => {
      const updateHeight = () => {
        setScrollbarHeight(window.innerWidth <= 768 ? 340 : 420);
      };

      updateHeight(); 
      window.addEventListener("resize", updateHeight);
      return () => window.removeEventListener("resize", updateHeight);
    }, []);

  return (
    <section className="text-center mx-5 my-12 lg:my-16 flex flex-col items-center" aria-labelledby="top-cities-heading">
      <div className="flex flex-col lg:flex-row items-center">
        <h2 id="top-cities-heading" className="font-poppins text-2xl lg:text-[38px] font-semibold text-textPrimary gap-2">
          Top{" "}
          <span className="text-olive inline-flex items-center mr-1">
            Cities
            <Image
              src={IMAGES.HeartIllustration}
              alt="Heart Illustration"
              width={34}
              height={33}
              className="align-middle -ml-1 mb-0 w-[34px] h-[33px] object-contain"
            />
          </span>
          we serve in India
        </h2>
      </div>
      <div className="mt-3 max-w-[785px] w-full text-sm lg:text-lg font-normal text-textSecondary leading-relaxed">
        Unlock the Essence of India’s Vibrant Cities with Us! Discover Unmatched
        Self Drive Rental Services in India’s Finest Urban Destinations.
      </div>

      <Scrollbars
        className={`scrollbar-style w-[95%]`}
        style={{ width: '95%', height: scrollbarHeight }}
      >
        <div className="mt-[30px] lg:mt-[50px] whitespace-nowrap min-h-[200px]">
          {Array.from({ length: numRows }).map((_, rowIndex) => (
            <div className="flex mb-[60px] lg:mb-20 min-w-max" key={rowIndex}>
              {(rowIndex === 0 ? elementsRow1 : elementsRow2).map((element) => (
                <div className="flex flex-col items-center w-auto box-border text-center mx-5 lg:mx-10 shrink-0" key={element.id}>
                  <Link href={`${BASE_URL_CITY}${element.linkUrl}`} className="group flex flex-col items-center no-underline text-inherit w-full">
                    <Image
                      src={`${element.imageUrl}`}
                      alt={`${element.cityName} bike rental`}
                      width={70}
                      height={70}
                      className="w-[70px] h-[70px] rounded-full object-cover shadow-card-sm transition-[transform,box-shadow] duration-200 group-hover:-translate-y-1 group-hover:shadow-card"
                    />
                    <p className="mt-[7px] lg:mt-5 text-textPrimary text-xs lg:text-sm font-medium whitespace-normal transition-colors group-hover:text-primary">{element.cityName}</p>
                  </Link>
                </div>
              ))}
            </div>
          ))}
        </div>
      </Scrollbars>
    </section>
  );
};

export default TopCities;
